import { TranslationMessages } from '../types';
import { app } from './app/nl';
import { settingsApp } from './app/nl';

const nl: TranslationMessages = {
  nav: {
    howItWorks: 'Hoe het werkt',
    why: 'Waarom?',
    features: 'Functies',
    getStarted: 'AAN DE SLAG',
    dashboard: 'Dashboard',
    blog: 'Blog',
  },
  hero: {
    title1: 'Telegram Stars',
    title2: 'Eenvoudig betaald worden',
    subtitle: 'Maak direct betaallinks, beheer je saldo en neem op in TON. 3% platformkosten.',
    cta: 'Aan de slag',
    hairsim: 'Simuleer uw haartransplantatie',
  },
  demo: {
    botName: 'Telegram Stars Bot',
    online: 'online',
    linkCreated: 'Betaallink aangemaakt.',
    invoiceTitle: 'Premium Access',
    invoiceDesc: 'Maandelijks abonnement',
    stars: 'Stars',
    payBtn: 'Betaal 100 Stars',
    iPayNow: 'Ik betaal nu',
    paymentLabel: 'Telegram Stars betaling',
    merchant: 'Handelaar',
    amount: 'Bedrag',
    confirmPay: 'Betaling bevestigen',
    paymentReceived: 'Betaling ontvangen — 100 Stars',
    invoiceCredited: 'Invoice #xk9m2 · bijgeschreven op saldo',
    thanks: 'Bedankt, toegang geactiveerd',
    messagePlaceholder: 'Bericht',
  },
  stats: {
    title: 'Vertrouwd door duizenden agenten',
    subtitle: 'Sluit je aan bij een groeiende community van handelaren die Telegram Stars betalingen gebruiken',
    activeAgents: 'Actieve agenten',
    transactions: 'Transacties',
    uptime: 'Beschikbaarheid',
    support: 'Support',
  },
  features: {
    title: 'Alles wat u nodig heeft voor Telegram Stars betalingen',
    subtitle: 'Een compleet platform om uw Telegram Stars betalingen te beheren',
    instantTitle: 'Direct aanmaken',
    instantDesc: 'Word in seconden agent. Geen configuratie vereist.',
    balanceTitle: 'Saldo beheer',
    balanceDesc: 'Volg uw omzet in realtime met een intuïtief dashboard.',
    paymentsTitle: 'Telegram Stars betalingen',
    paymentsDesc: 'Accepteer betalingen in Telegram Stars via uw bot.',
    securityTitle: 'Maximale beveiliging',
    securityDesc: 'Onveranderlijk grootboek, veilige en transparante transacties.',
    withdrawTitle: 'TON-opnames',
    withdrawDesc: 'Neem uw saldo direct op naar uw TON-adres.',
    apiTitle: 'Robuuste API',
    apiDesc: 'Eenvoudige integratie met webhooks en een complete REST API.',
  },
  how: {
    title: 'Hoe het werkt',
    subtitle: 'Begin in 3 eenvoudige stappen',
    startDemo: 'Demo starten',
    demoRunning: 'Demo actief...',
    reset: 'Resetten',
    step1Title: '1. Registreren',
    email: 'E-mail',
    password: 'Wachtwoord',
    noCard: '✓ Geen creditcard vereist',
    step2Title: '2. Betaallinks maken',
    amountStars: 'Bedrag (Stars)',
    generatedLink: 'Gegenereerde link:',
    shareLink: '✓ Deel deze link met uw klanten',
    step3Title: '3. Saldo opnemen',
    tonAddress: 'TON-adres',
    availableBalance: 'Beschikbaar saldo:',
    fee: 'Kosten: 3%',
  },
  pricing: {
    title: 'Eenvoudige en transparante prijzen',
    subtitle: 'Geen verborgen kosten, geen verplichtingen',
    commission: 'Commissie',
    perTransaction: 'per transactie',
    freeAccount: 'Gratis account aanmaken',
    noMonthly: 'Geen maandelijkse kosten',
    tonWithdrawals: 'Geïntegreerde TON-opnames',
    completeDashboard: 'Compleet dashboard',
    support247: '24/7 support',
    startNow: 'Nu starten',
  },
  faq: {
    title: 'Veelgestelde vragen',
    subtitle: 'Alles wat u moet weten over Telegram Stars betalingen',
    q1: 'Hoe werkt Telegram Stars betaling?',
    a1: 'Telegram Stars betaling stelt handelaren in staat om betalingen direct via Telegram te accepteren. Gebruikers maken betaallinks, delen deze met klanten en ontvangen betalingen in Telegram Stars valuta.',
    q2: 'Wat zijn de platformkosten?',
    a2: 'De platformkosten bedragen 3% per transactie. Dit dekt betalingsverwerking, grootboekbeheer en platformonderhoud. Er zijn geen installatiekosten of maandelijkse kosten.',
    q3: 'Hoe neem ik mijn Telegram Stars op?',
    a3: 'U kunt opnames aanvragen naar uw TON-wallet. Opnames worden handmatig verwerkt voor de veiligheid. Minimale opname is 100 Stars.',
    q4: 'Is Telegram Stars betaling veilig?',
    a4: 'Ja, alle betalingen worden verwerkt via het beveiligde betalingssysteem van Telegram. We gebruiken industriestandaard encryptie en beveiligingspraktijken.',
    q5: 'Wat zijn Telegram Stars?',
    a5: 'Telegram Stars is een virtuele valuta binnen Telegram voor betalingen. Gebruikers kunnen Stars kopen en gebruiken om te betalen voor diensten, producten en abonnementen.',
    q6: 'Kan ik Telegram Stars betalingen gebruiken voor mijn bedrijf?',
    a6: 'Ja! Telegram Stars Payment Platform is ontworpen voor handelaren, creators en bedrijven. U kunt betalingen accepteren voor digitale producten, diensten, abonnementen en meer.',
  },
  cta: {
    title: 'Klaar om te beginnen?',
    subtitle: 'Sluit u aan bij duizenden agenten die ons platform al gebruiken',
    createAccount: 'Gratis account aanmaken',
    signIn: 'Inloggen',
  },
  footer: {
    description: 'Compleet SaaS-platform voor Telegram Stars betalingen',
    product: 'Product',
    features: 'Functies',
    pricing: 'Prijzen',
    support: 'Support',
    signIn: 'Inloggen',
    docs: 'Documentatie',
    copyright: '© 2024 Telegram Stars Payment Platform. Alle rechten voorbehouden.',
  },
  seo: {
    title: 'Telegram Stars Payment Platform | Accepteer betalingen via Telegram Stars',
    description: 'Accepteer betalingen via Telegram Stars. Maak direct betaallinks, beheer uw saldo en neem op in TON. 3% platformkosten. Begin vandaag nog met het accepteren van Telegram Stars betalingen.',
    keywords: 'telegram stars betaling, telegram stars accepteren, telegram stars payment platform, telegram stars betaalgateway',
  },
  whyPage: {
    seoTitle: 'Waarom Telegram Stars Payment Platform | Voordelen',
    seoDescription: 'Ontdek waarom handelaren en creators kiezen voor Telegram Stars Payment Platform: directe setup, transparante prijzen, veilige betalingen en wereldwijd bereik.',
    title: 'Waarom voor ons kiezen?',
    subtitle: 'Gebouwd voor handelaren en creators die eenvoudige Telegram Stars betalingen willen',
    r1Title: 'Directe setup',
    r1Desc: 'Begin in seconden. Geen complexe configuratie of technische kennis vereist.',
    r2Title: 'Transparante prijzen',
    r2Desc: 'Slechts 3% per transactie. Geen verborgen kosten, geen maandelijkse kosten, geen installatiekosten.',
    r3Title: 'Veilig en betrouwbaar',
    r3Desc: 'Gebouwd op de beveiligde betalingsinfrastructuur van Telegram met industriestandaard encryptie.',
    r4Title: 'Wereldwijd bereik',
    r4Desc: 'Accepteer betalingen van Telegram-gebruikers wereldwijd. Geen geografische beperkingen.',
    r5Title: 'Eenvoudige integratie',
    r5Desc: 'Eenvoudige API en webhooks. Integreer met uw bestaande systemen in minuten.',
    r6Title: 'TON-opnames',
    r6Desc: 'Neem direct op naar uw TON-wallet. Snelle en veilige opnames.',
  },
  howPage: {
    seoTitle: 'Hoe het werkt | Telegram Stars Payment Platform',
    seoDescription: 'Leer hoe u in 3 eenvoudige stappen betalingen via Telegram Stars accepteert. Maak uw account, genereer betaallinks en neem op in TON.',
    title: 'Hoe het werkt',
    subtitle: 'Accepteer Telegram Stars betalingen in drie eenvoudige stappen',
  },
  settings: {
    title: "Instellingen",
    languageSection: "Taal",
    defaultLanguage: "Standaardtaal",
    languageHint: "Deze taal geldt voor het hele platform (landingspagina’s en interface).",
    languageSaved: "Taal bijgewerkt",
    ...settingsApp,
  },
  app,
};

export default nl;
